import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  uid: null,
  name: '',
  email: '',
  userIntent: null,
  color: null,
  character: null,
  courseCompletions: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,

  reducers: {
    updateUid: (state, action) => {
      state.uid = action.payload
    },
    setName: (state, action) => {
      state.name = action.payload
    },
    setEmail: (state, action) => {
      state.email = action.payload
    },
    updateUserIntent: (state, action) => {
      state.userIntent = action.payload
    },
    setUidDetails: (state, action) => {
      // Used by Firebase wrapper when syncing from server (user node)
      const payload = action.payload
      state.name = payload?.name ?? state.name
      state.userIntent = payload?.userIntent ?? state.userIntent
      state.color = payload?.color ?? state.color
      state.character = payload?.character ?? state.character
      state.courseCompletions = payload?.courseCompletions ?? state.courseCompletions
    },
    resetUser: (state) => {
      const uid = state.uid
      return { ...initialState, uid }
    },
    clearUserProfileKeepingCompletions: (state) => {
      state.name = initialState.name
      state.email = initialState.email
      state.userIntent = initialState.userIntent
      state.color = initialState.color
      state.character = initialState.character
      // keep uid and courseCompletions
    },
    clearCourseCompletions: (state) => {
      state.courseCompletions = null
    },
  },
})

export const {
  updateUid,
  setName,
  setEmail,
  updateUserIntent,
  setUidDetails,
  resetUser,
  clearUserProfileKeepingCompletions,
  clearCourseCompletions,
} = userSlice.actions

export default userSlice.reducer
